import { render, staticRenderFns } from "./Dish.vue?vue&type=template&id=6e3a4611"
import script from "./Dish.vue?vue&type=script&lang=ts"
export * from "./Dish.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports